export enum PolicyTypeEnum {
  Expiring = "expiringPolicies",
  Installments = "policiesInstallments",
}

export enum PolicyURLEnum {
  Expiring = "/references/expiring-policies",
}

export interface PolicyReferenceProps {
  policyFetchType: PolicyTypeEnum;
}
